import { render, staticRenderFns } from "./DayBlockEditor.vue?vue&type=template&id=8275c2c6&scoped=true&"
import script from "./DayBlockEditor.vue?vue&type=script&lang=js&"
export * from "./DayBlockEditor.vue?vue&type=script&lang=js&"
import style0 from "./DayBlockEditor.vue?vue&type=style&index=0&id=8275c2c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8275c2c6",
  null
  
)

export default component.exports